/**
 * Shared column header component that renders a label with an optional info-icon tooltip.
 * Extracted from the local HeaderWithTooltip in SocialSignals.tsx so that any table or
 * dashboard can reuse the same "label + info icon" pattern without duplicating Meridian
 * wiring for Tooltip, Icon, and Row.
 */
import React from 'react';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';

interface TooltipHeaderProps {
  readonly label: string;
  readonly tooltip?: string;
}

export const TooltipHeader: React.FC<TooltipHeaderProps> = ({ label, tooltip }) => {
  if (!tooltip) {
    return (
      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {label}
      </span>
    );
  }

  return (
    <Row alignmentVertical="center" spacing="100">
      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</span>
      <Tooltip position="top" title={tooltip}>
        <span style={{ display: 'inline-flex', cursor: 'help' }}>
          <Icon tokens={infoKnockoutTokens} />
        </span>
      </Tooltip>
    </Row>
  );
};
